let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("k9tXG"), load("1PRCI"), load("S8gOj")]).then(() => parcelRequire('j3Xd0'));